__turbopack_context__.v({
  "appBadgesContainer": "styles-module__ViChGq__appBadgesContainer",
  "appIcon": "styles-module__ViChGq__appIcon",
  "badges": "styles-module__ViChGq__badges",
  "card": "styles-module__ViChGq__card",
  "card--titled": "styles-module__ViChGq__card--titled",
  "content": "styles-module__ViChGq__content",
  "content--compact": "styles-module__ViChGq__content--compact",
  "content--titled": "styles-module__ViChGq__content--titled",
  "desktopText": "styles-module__ViChGq__desktopText",
  "mobileText": "styles-module__ViChGq__mobileText",
  "qrCodeContainer": "styles-module__ViChGq__qrCodeContainer",
  "textContainer": "styles-module__ViChGq__textContainer",
});
